export default "__VITE_PUBLIC_ASSET__55a9da9b__"